import type {
  AutocompletePhysicalLocationResult,
  QueryAutocompletePhysicalLocationsArgs,
} from '@tribeplatform/gql-client/types'
import { AutocompletePhysicalLocationResultFields } from '@tribeplatform/gql-client/types/generated'

import { useQuery, UseQueryOptions } from '../../lib/index.js'
import { useTribeClient } from '../../useTribeClient.js'

import { getAutocompletePhysicalLocationsKey } from './event.key.js'

export const useAutocompletePhysicalLocation = (options: {
  variables: QueryAutocompletePhysicalLocationsArgs
  fields?: AutocompletePhysicalLocationResultFields
  useQueryOptions?: UseQueryOptions<AutocompletePhysicalLocationResult>
}) => {
  const { variables, fields, useQueryOptions } = options || {}
  const key = getAutocompletePhysicalLocationsKey({ variables, fields })
  const { client } = useTribeClient()

  return useQuery<AutocompletePhysicalLocationResult>(
    key,
    () =>
      client.events.autocompletePhysicalLocations(variables, fields ?? 'basic'),
    useQueryOptions,
  )
}
